import { Form } from "components/ResumeForm/Form";
import RichEditor from "./Form/QuillEditor";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { selectSkills, changeSkills } from "lib/redux/resumeSlice";
import RichEditorWithSuggestions from "./Form/RichEditorWithSuggestions";

export const SkillsForm = () => {
  const skills = useAppSelector(selectSkills);
  const dispatch = useAppDispatch();
  const { descriptions } = skills;
  const form = "skills";

  const handleSkillsChange = (field: "descriptions", value: string[]) => {
    dispatch(changeSkills({ field, value }));
  };

  return (
    <Form form={form}>
      <div className="col-span-full grid grid-cols-6 gap-3">
        <div className="relative col-span-full">
          {/* <RichEditor
            name="descriptions"
            value={descriptions}
            onChange={handleSkillsChange}
            labelClassName="col-span-full"
            placeholder="List your skills here"
          /> */}
          <RichEditorWithSuggestions
            name="descriptions"
            value={descriptions}
            onChange={handleSkillsChange}
            placeholder="List your Skills here"
            section="skills"
          />
        </div>
        <div className="col-span-full mb-4 mt-6 border-t-2 border-dotted border-gray-200" />
      </div>
    </Form>
  );
};
